import { render, staticRenderFns } from "./AllProvidersIframe.vue?vue&type=template&id=b6edcb00&"
import script from "./AllProvidersIframe.vue?vue&type=script&lang=js&"
export * from "./AllProvidersIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports